import React, { useEffect, useState } from "react";
import "./AmazoniaDiplomaticaFormulario.css";

const API = "/api/amazoniadiplomatica";
const ENVIO_HABILITADO = true;



const DOCUMENTOS = [
  ["identidade", "Documento de identificação com foto (RG ou certidão de nascimento acompanhada de documento do responsável)"],
  ["matricula", "Comprovante ou atestado de matrícula ativa no Ensino Médio Regular, emitido por escola pública ou privada do Acre"],
  ["autorizacao", "Termo de Autorização dos Pais ou Responsáveis Legais e Licença de Uso de Imagem e Voz, assinado conforme o Anexo I do edital"],
];

const ESTUDANTE_INICIAL = {
  nome: "",
  cpf: "",
  email: "",
  telefone: "",
  data_nascimento: "",
  escola: "",
  municipio: "",
  serie: "",
  position_paper_texto: "",
};

const TAMANHO_MAXIMO = 15 * 1024 * 1024;

function validarCPF(valor) {
  const cpf = valor.replace(/\D/g, "");

  if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) {
    return false;
  }

  for (let tamanho = 9; tamanho < 11; tamanho++) {
    let soma = 0;

    for (let indice = 0; indice < tamanho; indice++) {
      soma += Number(cpf[indice]) * (tamanho + 1 - indice);
    }

    const resto = (soma * 10) % 11;
    const digito = resto === 10 ? 0 : resto;

    if (digito !== Number(cpf[tamanho])) {
      return false;
    }
  }

  return true;
}

function Campo({
  label,
  name,
  value,
  onChange,
  type = "text",
}) {
  return (
    <label className="adf-field">
      <span>{label}</span>

      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        required
        autoComplete="off"
      />
    </label>
  );
}

function DadosEstudante({
  indice,
  estudante,
  atualizar,
  atualizarArquivo,
  arquivos,
  delegacao,
}) {
  const alterar = (evento) => {
    atualizar(indice, evento.target.name, evento.target.value);
  };

  return (
    <section className="adf-student">
      <div className="adf-student-heading">
        <span className="adf-student-index">
          {String(indice + 1).padStart(2, "0")}
        </span>

        <div>
          <h3>
            {delegacao
              ? indice === 0
                ? "Delegado Oficial"
                : "Delegado Suplente"
              : "Dados do estudante"}
          </h3>

          <p>Preencha as informações conforme seus documentos.</p>
        </div>
      </div>

      <div className="adf-fields">
        <Campo
          label="Nome completo"
          name="nome"
          value={estudante.nome}
          onChange={alterar}
        />

        <Campo
          label="CPF"
          name="cpf"
          value={estudante.cpf}
          onChange={alterar}
        />

        <Campo
          label="E-mail"
          name="email"
          type="email"
          value={estudante.email}
          onChange={alterar}
        />

        <Campo
          label="Telefone / WhatsApp"
          name="telefone"
          type="tel"
          value={estudante.telefone}
          onChange={alterar}
        />

        <Campo
          label="Data de nascimento"
          name="data_nascimento"
          type="date"
          value={estudante.data_nascimento}
          onChange={alterar}
        />

        <Campo
          label="Escola"
          name="escola"
          value={estudante.escola}
          onChange={alterar}
        />

        <Campo
          label="Município"
          name="municipio"
          value={estudante.municipio}
          onChange={alterar}
        />

        <label className="adf-field">
          <span>Série / ano</span>

          <select
            name="serie"
            value={estudante.serie}
            onChange={alterar}
            required
          >
            <option value="">Selecione</option>
            <option value="1_ano">1º ano</option>
            <option value="2_ano">2º ano</option>
            <option value="3_ano">3º ano</option>
            <option value="4_ano">4º ano</option>
          </select>
        </label>
      </div>

      <div className="adf-position-paper">
        <h4>Por que você quer participar?</h4>

        <p>
          Conte brevemente por que você deseja participar
          da Amazônia Diplomática.
          Cada estudante deve apresentar sua própria resposta,
          com até 150 caracteres.
        </p>

        <label className="adf-field">
          <span>
            Seu interesse em participar (máximo de 150 caracteres)
          </span>

          <textarea
            name="position_paper_texto"
            value={estudante.position_paper_texto}
            onChange={alterar}
            maxLength={150}
            minLength={1}
            rows={4}
            required
            placeholder="Escreva sua resposta aqui..."
            aria-describedby={`adf-contador-${indice}`}
          />

          <small
            id={`adf-contador-${indice}`}
            className="adf-character-counter"
          >
            {estudante.position_paper_texto.length}/150 caracteres
          </small>
        </label>
      </div>

      <div className="adf-documents">
        <h4>Documentos do estudante</h4>

        <p>
          Envie arquivos PDF, JPG ou PNG, com até 15 MB por arquivo.
          Cada estudante deverá apresentar sua documentação individual.
        </p>

        <div className="adf-doc-grid">
          {DOCUMENTOS.map(([tipo, titulo]) => (
            <label className="adf-upload" key={tipo}>
              <span>{titulo}</span>

              <input
                type="file"
                accept=".pdf,.jpg,.jpeg,.png"
                required
                onChange={(evento) =>
                  atualizarArquivo(
                    indice,
                    tipo,
                    evento.target.files?.[0] || null
                  )
                }
              />

              <small>
                {arquivos[`${indice + 1}:${tipo}`]?.name ||
                  "PDF, JPG ou PNG — máximo 15 MB"}
              </small>
            </label>
          ))}
        </div>
      </div>
    </section>
  );
}

export default function AmazoniaDiplomaticaFormulario() {
  const [modalidade, setModalidade] = useState("");
  const [estudantes, setEstudantes] = useState([
    { ...ESTUDANTE_INICIAL },
    { ...ESTUDANTE_INICIAL },
  ]);

  const [arquivos, setArquivos] = useState({});
  const [ciencia, setCiencia] = useState(false);

  const [periodoAberto, setPeriodoAberto] = useState(false);
  const [consultando, setConsultando] = useState(true);
  const [enviando, setEnviando] = useState(false);
  const [erro, setErro] = useState("");
  const [protocolo, setProtocolo] = useState("");

  const delegacao = modalidade === "delegacao";
  const quantidade = delegacao ? 2 : 1;

  useEffect(() => {
    let ativo = true;

    async function consultarPeriodo() {
      try {
        const resposta = await fetch(`${API}/health`, {
          cache: "no-store",
        });

        if (!resposta.ok) {
          throw new Error("Não foi possível consultar o período.");
        }

        const dados = await resposta.json();

        if (ativo) {
          setPeriodoAberto(dados.inscricoes_abertas === true);
        }
      } catch {
        if (ativo) {
          setPeriodoAberto(false);
        }
      } finally {
        if (ativo) {
          setConsultando(false);
        }
      }
    }

    consultarPeriodo();

    return () => {
      ativo = false;
    };
  }, []);

  const atualizarEstudante = (indice, campo, valor) => {
    setEstudantes((anteriores) =>
      anteriores.map((estudante, posicao) =>
        posicao === indice
          ? { ...estudante, [campo]: valor }
          : estudante
      )
    );
  };

  const atualizarArquivo = (indice, tipo, arquivo) => {
    setArquivos((anteriores) => ({
      ...anteriores,
      [`${indice + 1}:${tipo}`]: arquivo,
    }));
  };

  const enviar = async (evento) => {
    evento.preventDefault();
    setErro("");

    if (!ENVIO_HABILITADO || !periodoAberto) {
      setErro("As inscrições ainda não estão disponíveis.");
      return;
    }

    if (enviando) {
      return;
    }

    if (!ciencia) {
      setErro("É necessário aceitar as condições do edital.");
      return;
    }

    const integrantes = estudantes
      .slice(0, quantidade)
      .map((estudante, indice) => ({
        ...estudante,
        cpf: estudante.cpf.replace(/\D/g, ""),
        ...(delegacao
          ? { funcao: indice === 0 ? "oficial" : "suplente" }
          : {}),
      }));

    for (let indice = 0; indice < integrantes.length; indice++) {
      if (!validarCPF(integrantes[indice].cpf)) {
        setErro(`CPF inválido: estudante ${indice + 1}.`);
        return;
      }
    }

    if (
      delegacao &&
      integrantes[0].cpf === integrantes[1].cpf
    ) {
      setErro("Os integrantes devem ser pessoas diferentes.");
      return;
    }

    for (let indice = 0; indice < integrantes.length; indice++) {
      const texto = integrantes[indice].position_paper_texto;

      if (
        typeof texto !== "string" ||
        !texto.trim() ||
        texto.length > 150
      ) {
        setErro(
          `Preencha o Documento de Posição do estudante ${indice + 1} (até 150 caracteres).`
        );
        return;
      }
    }

    const formulario = new FormData();
    const identificadores = [];

    for (let indice = 0; indice < quantidade; indice++) {
      for (const [tipo] of DOCUMENTOS) {
        const arquivo = arquivos[`${indice + 1}:${tipo}`];

        if (!arquivo) {
          setErro(
            `Documento obrigatório não enviado: estudante ${indice + 1}.`
          );
          return;
        }

        if (arquivo.size > TAMANHO_MAXIMO || arquivo.size === 0) {
          setErro(
            `Arquivo vazio ou acima de 15 MB: estudante ${indice + 1}.`
          );
          return;
        }

        const extensao = arquivo.name
          .split(".")
          .pop()
          ?.toLowerCase();

        if (!["pdf", "jpg", "jpeg", "png"].includes(extensao)) {
          setErro("Envie somente documentos PDF, JPG ou PNG.");
          return;
        }

        formulario.append("documentos", arquivo);

        identificadores.push({
          integrante: indice + 1,
          tipo,
        });
      }
    }

    const payload = {
      modalidade,
      integrantes,
      ciencia_edital: true,
    };

    formulario.append("payload", JSON.stringify(payload));

    formulario.append(
      "identificadores_documentos",
      JSON.stringify(identificadores)
    );

    setEnviando(true);

    try {
      const resposta = await fetch(`${API}/inscricoes`, {
        method: "POST",
        body: formulario,
      });

      const resultado = await resposta.json();

      if (!resposta.ok) {
        const detalhe = resultado.detail;

        throw new Error(
          typeof detalhe === "string"
            ? detalhe
            : "Não foi possível concluir a inscrição."
        );
      }

      if (!resultado.sucesso || !resultado.protocolo) {
        throw new Error("Resposta de confirmação inválida.");
      }

      setProtocolo(resultado.protocolo);
    } catch (falha) {
      setErro(
        falha.message ||
          "Falha de comunicação. Tente novamente."
      );
    } finally {
      setEnviando(false);
    }
  };

  if (protocolo) {
    return (
      <div className="adf-wrapper">
        <div className="adf-block" style={{ textAlign: "center" }}>
          <h2>Inscrição recebida!</h2>

          <p>Guarde seu número de protocolo:</p>

          <div
            style={{
              fontSize: "30px",
              fontWeight: 800,
              margin: "25px 0",
              color: "#087f89",
            }}
          >
            {protocolo}
          </div>

          <p>
            O protocolo confirma o recebimento da inscrição,
            não a seleção para o evento.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="adf-wrapper">
      <div className="adf-heading">
        <span className="ad-label">PROCESSO SELETIVO 2026</span>
        <h2>Formulário de inscrição</h2>

        <p>
          Preencha os dados e organize os documentos
          para participar da Amazônia Diplomática.
        </p>
      </div>

      <div className="adf-test-banner" role="status">
        <strong>
          {consultando
            ? "Consultando período de inscrições"
            : !ENVIO_HABILITADO
              ? "Formulário em fase de testes"
              : periodoAberto
                ? "Inscrições abertas"
                : "Inscrições indisponíveis"}
        </strong>

        <span>
          {!ENVIO_HABILITADO
            ? "O preenchimento e a seleção de arquivos são permitidos para testes. Nenhum dado será enviado nesta versão."
            : periodoAberto
              ? "Confira os dados e documentos antes de enviar."
              : "O envio de inscrições está fora do período permitido."}
        </span>
      </div>

      <form onSubmit={enviar}>
        <div className="adf-block">
          <h3>01. Como você deseja participar?</h3>

          <p className="adf-modality-instruction">
            <strong>Clique em uma das opções abaixo</strong>
            {" "}para abrir o formulário correspondente.
            Após selecionar, os campos de inscrição aparecerão
            automaticamente.
          </p>

          <div className="adf-modalities">
            {[
              ["delegacao", "Delegações", "Clique para inscrever uma dupla: Delegado Oficial e Suplente"],
              ["mesa_diretora", "Mesa Diretora", "Clique para realizar uma inscrição individual"],
              ["imprensa", "Imprensa", "Clique para realizar uma inscrição individual"],
            ].map(([valor, titulo, descricao]) => (
              <label
                className={`adf-modality ${
                  modalidade === valor ? "adf-selected" : ""
                }`}
                key={valor}
              >
                <input
                  type="radio"
                  name="modalidade"
                  value={valor}
                  checked={modalidade === valor}
                  onChange={() => {
                    setModalidade(valor);
                    setErro("");
                  }}
                />

                <strong>{titulo}</strong>
                <span>{descricao}</span>
              </label>
            ))}
          </div>
        </div>

        {modalidade && (
          <>
            <div className="adf-block">
              <h3>02. Identificação dos participantes</h3>

              {estudantes
                .slice(0, quantidade)
                .map((estudante, indice) => (
                  <DadosEstudante
                    key={indice}
                    indice={indice}
                    estudante={estudante}
                    atualizar={atualizarEstudante}
                    atualizarArquivo={atualizarArquivo}
                    arquivos={arquivos}
                    delegacao={delegacao}
                  />
                ))}
            </div>

            <div className="adf-block">
              <h3>03. Comitês e distribuição dos países</h3>

              <p>
                Todos os participantes atuarão nos dois comitês:
              </p>

              <ul>
                <li>
                  <strong>Conselho do Mercado Comum — MERCOSUL</strong>
                </li>
                <li>
                  <strong>Assuntos Sociais e Climáticos</strong>
                </li>
              </ul>

              <div className="adf-info-box">
                <strong>Como serão definidos os países?</strong>

                <p>
                  Não é necessário escolher um país na inscrição.
                  A distribuição dos países será realizada
                  posteriormente, por sorteio conduzido
                  pela Comissão Organizadora, exclusivamente
                  entre as duplas selecionadas como delegações.
                </p>

                <p>
                  A definição das funções e a organização
                  das atividades permanecem sob responsabilidade
                  da Comissão Organizadora.
                </p>
              </div>
            </div>

            <div className="adf-block">
              <h3>04. Como funciona a seleção</h3>

              <p>
                Conforme os itens 8.3 e 8.4 do edital,
                a seleção será conduzida pela Comissão
                Organizadora em duas etapas sucessivas.
              </p>

              <p>
                <strong>Etapa 1 — Habilitação documental
                (eliminatória):</strong> verificação dos
                requisitos de elegibilidade, do preenchimento
                da inscrição, da documentação obrigatória
                e do vínculo escolar ativo no Ensino Médio
                do Estado do Acre.
              </p>

              <p>
                <strong>Etapa 2 — Análise qualitativa e
                seleção curatorial (classificatória e
                eliminatória):</strong> avaliação do
                resposta breve de interesse e motivação,
                preenchida no formulário,
                pela Comissão Organizadora.
              </p>

              <p>
                <strong>Critérios observados na avaliação:</strong>
              </p>

              <ul>
                <li>
                  Clareza e objetividade da resposta.
                </li>
                <li>
                  Interesse e motivação para participar.
                </li>
                <li>
                  Adequação da resposta à proposta do evento.
                </li>
              </ul>

              <p>
                A ausência de documentos obrigatórios ou
                o descumprimento dos requisitos de
                elegibilidade poderá resultar na
                inabilitação da candidatura.
              </p>
            </div>

            <div className="adf-block">
              <h3>05. Ciência do edital</h3>

              <label className="adf-consent">
                <input
                  type="checkbox"
                  checked={ciencia}
                  onChange={(evento) =>
                    setCiencia(evento.target.checked)
                  }
                  required
                />

                <span>
                  Declaro que li as condições do processo seletivo
                  e estou ciente das exigências do{" "}
                  <a
                    href="/downloads/edital-amazonia-diplomatica-2026.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(evento) => evento.stopPropagation()}
                    style={{
                      color: "#087f89",
                      fontWeight: 700,
                      textDecoration: "underline"
                    }}
                  >
                    edital
                  </a>
                  .
                </span>
              </label>

              {erro && (
                <p role="alert" style={{ color: "#a12626" }}>
                  {erro}
                </p>
              )}

              <button
                className="adf-submit"
                type="submit"
                disabled={
                  !ENVIO_HABILITADO ||
                  !periodoAberto ||
                  consultando ||
                  enviando
                }
              >
                {enviando
                  ? "Enviando inscrição..."
                  : !ENVIO_HABILITADO
                    ? "Envio indisponível — fase de testes"
                    : "Confirmar inscrição"}
              </button>

              <p className="adf-footnote">
                O protocolo será apresentado após a confirmação
                do recebimento da sua inscrição.
              </p>
            </div>
          </>
        )}
      </form>
    </div>
  );
}
